var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyePassword = function SvgEyePassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M22 7.4a1.5 1.5 0 0 1 0 1.9c-.9 1.2-2.3 2.8-4 4.1-1.9 1.4-3.9 2.3-6 2.3s-4.1-1-6-2.3c-1.7-1.3-3.2-3-4-4.1a1.5 1.5 0 0 1 0-1.9c.9-1.1 2.3-2.8 4-4.1C8 2 10 1 12 1s4.1 1 6 2.3c1.7 1.3 3.2 3 4 4.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m15.8 4.4-3.8 5 5.4-.5a5.5 5.5 0 1 1-1.6-4.5z",
    clipRule: "evenodd"
  })));
};
export default SvgEyePassword;